<script>
	// svelte/d3 libs
	// import * as d3 from 'd3';
	import { line as d3line} from 'd3';
	import { scaleLinear } from 'd3-scale';
    import State from '../stores/State.js'; 


	

	// data
	export let driverLaps;
	export let race;

	export let hoverDriver = "";
	let winW;


	let width = 210;
	let height = 135;

	$: driverLaps.push(driverLaps.splice(driverLaps.findIndex(o => o.driver === $State.selDriver), 1)[0]);

	const padding = { top: 5, right: 5, bottom: 5, left: 5 };

	$: allPoints = flattenDL(driverLaps);

	let xExtent = [race.minP105, race.maxP105];

	let l_x = scaleLinear()
		.domain([race.minP105, race.maxP105])
		.range([padding.left, width - padding.right]);

	let l_y = scaleLinear()
		.domain([race.race === 'Belgium' ? 0 : 1, race.lapCount])
		.range([padding.top, height - padding.bottom]);




	let chartLine = d3line()
		.x(function(d) { return l_x(d.vsP105); }) 
		.y(function(d) { return l_y(d.lap); });
		// .curve(curveMonotoneY);



	const flattenDL = (data) => {
		let x = [];
		for (const d of data) {
			for (const l of d.laps) {
				x.push(l);
			}
		}
		return x
	}


    const chartClick = (e) => {
		if (hoverDriver !== "") $State.selDriver = hoverDriver;
		hoverDriver = "";
	}

	const pathMouseOver = (e) => {
		hoverDriver = e.target.dataset.value;
		if (hoverDriver === $State.selDriver) hoverDriver = "";
	}

</script>




	<!-- For some reason binding breaks safari in this chart - width gets set to zero -->
	<!-- bind:clientWidth={width} bind:clientHeight={height}  -->
<div class="chart">
	<div class="gridTitle">{race.race}</div>
	<svg class="miniLRPlot" 
	on:click="{chartClick}">
		<defs>
			<linearGradient id="grad-blue2whiteTween" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop stop-color="#5C86B5" stop-opacity="{0.2}"/>
				<stop offset="0.7" stop-color="#5C86B5" stop-opacity="0.5"/>
				<stop offset="0.95" stop-color="#5C86B5"/>
				<stop offset="0.98" stop-color="#B2CAE6"/>
				<stop offset="1" stop-color="#B2CAE6"/>
			</linearGradient>
			<linearGradient id="grad-red2whiteTween" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop stop-color="#FF3263" stop-opacity="0.7"/>
				<stop offset="0.7" stop-color="#FF3263" stop-opacity="0.8"/>
				<stop offset="1" stop-color="#FF3263"/>
			</linearGradient>
		</defs>
		


		
		<!-- chart elements -->		
		<g class="bolts">
			{#each driverLaps as driver, i (driver.driver + driver.laps[0].race + ($State.intro.length > 1))}

				<!-- <path class="path-line" d="{chartLine(driver.laps)}" out:fade="{{duration: 300}}"></path> -->
				<path 
					class="path-line" 
					data-value="{driver.driver}" 
					class:highlighted="{driver.driver === hoverDriver}" 
					class:selected="{driver.driver === $State.selDriver}" 
					d="{chartLine(driver.laps)}"  
					on:mouseover="{pathMouseOver}"
				>
				</path>
			{/each}
		</g>


		
	</svg>

</div>


		
	
<style>

	.gridTitle {
		text-align: center;
	}

	.chart {
		display: inline-block;
	}

	svg {
		position: relative;
		width: 210px;
		height: 135px;
		overflow: hidden;
	}

	.path-line {
		fill: none;
		stroke: url(#grad-blue2whiteTween);
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 2;
	}	
	.path-line.highlighted {
		stroke:  url(#grad-grey2white);
		stroke-width: 3;
	}	
	
	
	.path-line.selected {
		stroke:  url(#grad-red2whiteTween);
		stroke-width: 3;
	}	



</style>